export default __webpack_public_path__ + "static/media/DCA_955x875.c9bd3614.jpg";